import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Container,
    Typography,
    CircularProgress,
    IconButton,
    useMediaQuery,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { collection, getDocs, query, limit, orderBy, startAfter } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import InfiniteScroll from "react-infinite-scroller";

import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function InfoList() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [ruleData, setRuleData] = useState([]);

    const [hasMore, setHasMore] = useState(true);
    const [lastVisible, setLastVisible] = useState(null);

    const isSP = useMediaQuery("(max-width:600px)");

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                await fetchData();
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchData = async () => {
        const ruleRef = collection(db, "houseRule");

        try {
            const q = query(ruleRef, orderBy("updateAt", "desc"), limit(10));
            const ruleSnap = await getDocs(q);

            if (ruleSnap.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            const rules = [];
            ruleSnap.forEach((doc) => {
                rules.push({
                    id: doc.data().id,
                    title: doc.data().title,
                    description: doc.data().description,
                    updateAt: doc.data().updateAt,
                });
            });
            setRuleData(rules);

            setLastVisible(ruleSnap.docs[ruleSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }

        setLoading(false);
    };

    const fetchMoreData = async () => {
        const ruleRef = collection(db, "houseRule");

        try {
            const q = query(ruleRef, orderBy("updateAt", "desc"), limit(10), startAfter(lastVisible));
            const ruleSnap = await getDocs(q);

            if (ruleSnap.empty) {
                setHasMore(false);
                return;
            }

            const rules = [];
            ruleSnap.forEach((doc) => {
                rules.push({
                    id: doc.data().id,
                    title: doc.data().title,
                    description: doc.data().description,
                    updateAt: doc.data().updateAt,
                });
            });
            setRuleData((prevData) => [...prevData, ...rules]);

            setLastVisible(ruleSnap.docs[ruleSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>House Rule List - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Box
                    sx={{ mt: 10 }}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="h6">ハウスルール</Typography>
                </Box>

                <InfiniteScroll
                    pageStart={0}
                    loadMore={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <Box
                            sx={{ m: 1 }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            key={0}
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Box sx={{ mt: 2 }}>
                        {ruleData.map((item, i) => (
                            <Accordion key={item.id} sx={{ backgroundColor: "rgba(10, 10, 10, 0.8)" }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Grid container alignItems="center">
                                        <Grid item xs={12} sm={3}>
                                            <Typography>
                                                {item.updateAt
                                                    .toDate()
                                                    .toLocaleString("ja-JP", {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                    })
                                                    .replace(/\//g, "/")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <Typography variant={isSP ? "h6" : "h5"}>{item.title}</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                        <Grid item xs={12} sm={3} />
                                        <Grid item xs={12} sm={9}>
                                            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", mb: 2 }}>
                                                {item.description}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                navigate(`/house-rule/${item.id}/edit`);
                                            }}
                                        >
                                            <EditIcon sx={{ mx: 1 }} />
                                            編集
                                        </Button>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </InfiniteScroll>
            </Container>
        </div>
    );
}

export default InfoList;
